import { BaseEntity } from "@app/models/rest/base-entity";
import { VisitTypeResource } from "@app/models/rest/visit-type-resource";
import {
  SkillRule,
  SkillRuleSkillProjection
} from "@app/models/rest/skill-rule";
import {
  HateoasProjection,
  HateoasResource
} from "@lagoshny/ngx-hateoas-client";

@HateoasResource("skillProfiles")
export class SkillProfile extends BaseEntity {
  description: string;
  visitTypeResourceList: VisitTypeResource[];
  skillRuleList: SkillRule[];
}

@HateoasProjection(SkillProfile, "anything")
export class SkillProfileRuleProjection extends BaseEntity {
  description: string;
  skillRuleList: SkillRuleSkillProjection[];
}
